import _SvgIcon from "@mui/material/SvgIcon";
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
export function MissingFacilityIcon(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon, _extends({
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13778_919)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.75 4C5.16421 4 5.5 4.33579 5.5 4.75V19.25C5.5 19.6642 5.16421 20 4.75 20C4.33579 20 4 19.6642 4 19.25V4.75C4 4.33579 4.33579 4 4.75 4Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.75 16C11.1642 16 11.5 16.3358 11.5 16.75V19.25C11.5 19.6642 11.1642 20 10.75 20C10.3358 20 10 19.6642 10 19.25V16.75C10 16.3358 10.3358 16 10.75 16Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9619 13.4619C14.2548 13.1693 14.7296 13.1693 15.0225 13.4619L16.9932 15.4326L18.9648 13.4619C19.2576 13.1694 19.7326 13.1694 20.0254 13.4619C20.3182 13.7547 20.318 14.2295 20.0254 14.5225L18.0537 16.4932L20.0254 18.4648C20.3182 18.7577 20.318 19.2325 20.0254 19.5254C19.7325 19.8183 19.2577 19.8183 18.9648 19.5254L16.9932 17.5537L15.0225 19.5254C14.7296 19.8183 14.2548 19.8183 13.9619 19.5254C13.6694 19.2325 13.6691 18.7576 13.9619 18.4648L15.9326 16.4932L13.9619 14.5225C13.6692 14.2296 13.6691 13.7547 13.9619 13.4619Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.75 10C11.1642 10 11.5 10.3358 11.5 10.75V13.25C11.5 13.6642 11.1642 14 10.75 14C10.3358 14 10 13.6642 10 13.25V10.75C10 10.3358 10.3358 10 10.75 10Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.75 4C17.1642 4 17.5 4.33579 17.5 4.75V12.25C17.5 12.6642 17.1642 13 16.75 13C16.3358 13 16 12.6642 16 12.25V4.75C16 4.33579 16.3358 4 16.75 4Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.75 4C11.1642 4 11.5 4.33579 11.5 4.75V7.25C11.5 7.66421 11.1642 8 10.75 8C10.3358 8 10 7.66421 10 7.25V4.75C10 4.33579 10.3358 4 10.75 4Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13778_919"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    height: "24",
    width: "24"
  }))));
}